var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSubstituteAuthorizedPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 92,
    viewBox: "0 0 112 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5971 40.5048C18.1467 40.5584 18.5489 41.0475 18.4952 41.5972C18.1771 44.8585 18.7126 49.6842 21.2833 53.5598C23.5281 56.9441 27.3951 59.7143 33.9226 60.0084L29.1678 55.686C28.7592 55.3144 28.7291 54.682 29.1006 54.2733C29.4721 53.8647 30.1045 53.8346 30.5132 54.2061L37.1726 60.2601C37.5813 60.6316 37.6114 61.2641 37.2399 61.6727L31.1859 68.3322C30.8143 68.7409 30.1819 68.771 29.7732 68.3995C29.3646 68.028 29.3345 67.3955 29.706 66.9869L34.2206 62.0208C26.877 61.7938 22.2906 58.6967 19.6166 54.6653C16.7207 50.2993 16.1562 44.9749 16.5047 41.403C16.5583 40.8533 17.0474 40.4512 17.5971 40.5048Z",
    fill: "#A7163E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "#FED3B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_16440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 33,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 33.8574C27.2574 33.8574 34.3569 26.7579 34.3569 18.0002C34.3569 9.24255 27.2574 2.14307 18.4997 2.14307C9.74206 2.14307 2.64258 9.24255 2.64258 18.0002C2.64258 26.7579 9.74206 33.8574 18.4997 33.8574Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_16440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8304 16.9107C21.5671 16.9107 23.7857 14.6921 23.7857 11.9554C23.7857 9.21859 21.5671 7 18.8304 7C16.0936 7 13.875 9.21859 13.875 11.9554C13.875 14.6921 16.0936 16.9107 18.8304 16.9107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 40.4643C24.7031 40.4643 29.7319 35.4355 29.7319 29.2321C29.7319 23.0288 24.7031 18 18.4997 18C12.2964 18 7.26758 23.0288 7.26758 29.2321C7.26758 35.4355 12.2964 40.4643 18.4997 40.4643Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 92C93.2254 92 108 77.2254 108 59C108 40.7746 93.2254 26 75 26C56.7746 26 42 40.7746 42 59C42 77.2254 56.7746 92 75 92Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_16440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 29,
    width: 58,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0006 86.3937C90.6223 86.3937 103.286 73.7297 103.286 58.108C103.286 42.4862 90.6223 29.8223 75.0006 29.8223C59.3788 29.8223 46.7148 42.4862 46.7148 58.108C46.7148 73.7297 59.3788 86.3937 75.0006 86.3937Z",
    fill: "#EDF5F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_16440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5893 56.9295C80.4711 56.9295 84.4286 52.9721 84.4286 48.0903C84.4286 43.2085 80.4711 39.251 75.5893 39.251C70.7075 39.251 66.75 43.2085 66.75 48.0903C66.75 52.9721 70.7075 56.9295 75.5893 56.9295Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0006 98.1793C86.066 98.1793 95.0363 89.209 95.0363 78.1436C95.0363 67.0782 86.066 58.1079 75.0006 58.1079C63.9351 58.1079 54.9648 67.0782 54.9648 78.1436C54.9648 89.209 63.9351 98.1793 75.0006 98.1793Z",
    fill: "#E62645"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36.5C112 42.299 107.299 47 101.5 47C95.701 47 91 42.299 91 36.5C91 30.701 95.701 26 101.5 26C107.299 26 112 30.701 112 36.5Z",
    fill: "#FF7D23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.723 35.1229H102.877V32.2769C102.877 31.516 102.261 30.8999 101.5 30.8999C100.739 30.8999 100.123 31.516 100.123 32.2769V35.1229H97.2774C96.5172 35.1229 95.9004 35.739 95.9004 36.4999C95.9004 37.2601 96.5172 37.8769 97.2774 37.8769H100.123V40.7222C100.123 41.4831 100.739 42.0999 101.5 42.0999C102.261 42.0999 102.877 41.4831 102.877 40.7222V37.8762H105.723C106.484 37.8762 107.1 37.2601 107.1 36.4992C107.1 35.739 106.484 35.1229 105.723 35.1229Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSubstituteAuthorizedPerson);
export default __webpack_public_path__ + "static/media/imgSubstituteAuthorizedPerson.3ba692cc7b8554bb4ba2d3fcf8698fdf.svg";
export { ForwardRef as ReactComponent };